import { inject, Injectable } from "@angular/core";
import { ComparatorOperators, ConformanceToGiasleField, ConformanceToGiasleQueryComplexInput, ConformanceToGiasleSimpleQueryInput, GetLegalEntityForKirsManageCampaignGQL, GetLegalEntityForKirsManageCampaignQuery, IcsCampaignLegalEntityColumns, IcsCampaignLegalEntityQueryComplexInput, IcsCampaignLegalEntitySimpleQueryInput, IcsCampaignLegalEntitySortInput, OperatorInput, OrderTypeInput, PagingInput } from "../../../graphql/generated";
import { map, Observable } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class ManageCampaignKirsService {
    private readonly GetLegalEntityForKirsManageCampaignGQL: GetLegalEntityForKirsManageCampaignGQL = inject(GetLegalEntityForKirsManageCampaignGQL);

    getLegalEntitiesConfermanceGias(campaignId: any, parameters: any): Observable<GetLegalEntityForKirsManageCampaignQuery['getLegalEntityForManageConformanceKirsCampaign']> {
        const param = convertLazyLoadToComplexWithoutPage(parameters);
        return this.GetLegalEntityForKirsManageCampaignGQL.fetch({
            campaignId, query: param.query as ConformanceToGiasleQueryComplexInput, page: {
                pageNo: param.page.pageNo,
                pageSize: param.page.pageSize
            }
        }, { fetchPolicy: 'no-cache' }).pipe(map(result => result.data.getLegalEntityForManageConformanceKirsCampaign));
    }

}

export function convertLazyLoadToComplexWithoutPage(parameters: any): { query: ConformanceToGiasleQueryComplexInput, page: PagingInput } {
    const query: ConformanceToGiasleSimpleQueryInput[] = [];
    if (parameters) {

        if (parameters.filters) {

            Object.entries(parameters.filters).forEach(([field, values]) => {
                //console.log"value", values);

                if (values !== null && Array.isArray(values) && values.length > 0) {
                    (ENUM_RISKMAP[field as keyof typeof ENUM_RISKMAP])?.forEach(key => {

                        query.push({
                            field: key as ConformanceToGiasleField,
                            filters: {
                                operator: ComparatorOperators.Match,
                                value: key !== ConformanceToGiasleField.LegalEntityCode ? key !== ConformanceToGiasleField.InScopeCurrentCampaign ? values : values.map(v => v?.toLowerCase() === 'yes' ? 'true' : 'false') : values.map(v => v?.split(/-(.+)/)[0]?.trim())
                            }
                        });
                    })
                }
            });
        }
    }
    return {
        query: {
            operator: OperatorInput.And,
            query: [
                {
                    query,
                    operator: OperatorInput.And
                }
            ]
        },
        page: {
            pageNo: parameters?.page ?? 0,
            pageSize: parameters?.rows ?? 20
        }
    }
}

export const ENUM_RISKMAP = {
    businessUnit: [ConformanceToGiasleField.BusinessUnit],
    organizationalUnit: [ConformanceToGiasleField.OrganizationalUnit],
    legalEntityName: [ConformanceToGiasleField.LegalEntityName],
    legalEntitySize: [ConformanceToGiasleField.LegalEntitySize],
    businessType: [ConformanceToGiasleField.BusinessType],
    valueChain: [ConformanceToGiasleField.ValueChain],
    category: [ConformanceToGiasleField.Category],
    auditControlApproach: [ConformanceToGiasleField.AuditControlApproach],
    startDate: [ConformanceToGiasleField.StartDate],
    status: [ConformanceToGiasleField.Status],
    inScope: [ConformanceToGiasleField.InScopeCurrentCampaign]
}